import React from 'react';

const HomeSingleSlide = ({ slider_class, content_class, attr_1, attr_2, attr_3 = "" }) => {
   return (
      <>
         <div className="single-slider single-slider-2 slider__height slider__height-2 tw-flex tw-items-center" style={{
            background: `url(assets/img/slider/02/slider-1.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover'
         }}>

            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className={`${slider_class}`}>
                     <div className={`slider__content slider__content-2 ${content_class && content_class}`}>
                        {attr_1 && attr_1}
                        {attr_2}
                        <p >{attr_3}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeSingleSlide;
